module.exports = __webpack_public_path__ + "img/decade_plan_of_action._eng-1.1aae39b8.jpg";